import { MembershipDetails } from "./workspace.types";

export function isActiveConfirmedMemeberShip(
  memberShip?: MembershipDetails
): boolean {
  return (
    memberShip !== undefined && memberShip.is_active && memberShip.is_confirmed
  );
}
